import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SubcatBanner from './SubcatBanner';
import SubcategoryImpressionable from './SubcategoryImpressionable';
import './style.scss';

export default class SubcategoryBanners extends Component {
    componentDidMount() {
        this.createImpressionable();
    }

    createImpressionable() {
        const {
            classname,
            title,
            carouselPosition,
            viewObject,
            banners
        } = this.props;

        const pageCtxId = viewObject.page_ctx_id;

        const enrichData = {
            itemContextType: 'sub_category',
            sourcepage: 'pro_homepage',
            pageCtxId,
            subCategoryName: title,
            carouselPosition
        };

        new SubcategoryImpressionable({
            container: document.querySelector(`.subcat-banner-wrapper.${classname}`),
            data: banners
        }, enrichData);
    }

    render() {
        const {
            title,
            classname,
            banners,
            position,
            viewObject
        } = this.props;

        const pageCtxId = viewObject.page_ctx_id;

        return (
            <section className="subcat-wrapper">
                <header>
                    <h3>{title}</h3>
                </header>

                <div className={`subcat-banner-wrapper ${classname}`}>
                    {banners.map((banner, index) => {
                        const {
                            link,
                            title,
                            image,
                            sub_category
                        } = banner;

                        return (
                            <SubcatBanner key={index}
                                index={index}
                                link={link}
                                title={title}
                                image={image}
                                categoryId={null}
                                categoryName={null}
                                subCategoryId={sub_category}
                                subCategoryName={title}
                                position={position}
                                pageCtxId={pageCtxId}/>
                        );
                    })}
                </div>
            </section>
        );
    }
}

SubcategoryBanners.propTypes = {
    classname: PropTypes.string,
    title: PropTypes.string,
    carouselPosition: PropTypes.number,
    viewObject: PropTypes.object,
    banners: PropTypes.array
};

SubcategoryBanners.defaultProps = {
    classname: 'top-services',
    position: 0,
    subCategoryId: 0,
    title: '',
    carouselPosition: 0,
    viewObject: {
        page_ctx_id: ''
    },
    banners: []
};



// WEBPACK FOOTER //
// ./src/common/HomePage/SubcategoryBanners/index.js